var getTypeOf = function (input) {
    if (input === null) {
        return 'null';
    }
    if (typeof input === 'undefined') {
        return 'undefined';
    }
    if (typeof input === 'object') {
        return (Array.isArray(input) ? 'array' : 'object');
    }
    return typeof input;
};
var cloneValue = function (value) {
    if (getTypeOf(value) === 'object') {
        return quickCloneObject(value);
    }
    if (getTypeOf(value) === 'array') {
        return quickCloneArray(value);
    }
    return value;
};
var quickCloneArray = function (input) {
    return input.map(cloneValue);
};
var quickCloneObject = function (input) {
    var output = {};
    for (var key in input) {
        if (!input.hasOwnProperty(key)) {
            continue;
        }
        output[key] = cloneValue(input[key]);
    }
    return output;
};
var executeDeepMerge = function (target, pObjects, pOptions) {
    if (pObjects === void 0) { pObjects = []; }
    if (pOptions === void 0) { pOptions = {}; }
    var options = {
        arrayBehaviour: pOptions.arrayBehaviour || 'replace',
    };
    var objects = pObjects.map(function (object) { return object || {}; });
    var output = target || {};
    for (var oindex = 0; oindex < objects.length; oindex += 1) {
        var object = objects[oindex];
        var keys = Object.keys(object);
        for (var kindex = 0; kindex < keys.length; kindex += 1) {
            var key = keys[kindex];
            var value = object[key];
            var type = getTypeOf(value);
            var existingValueType = getTypeOf(output[key]);
            if (type === 'object') {
                if (existingValueType !== 'undefined') {
                    var existingValue = (existingValueType === 'object' ? output[key] : {});
                    output[key] = executeDeepMerge({}, [existingValue, quickCloneObject(value)], options);
                }
                else {
                    output[key] = quickCloneObject(value);
                }
            }
            else if (type === 'array') {
                if (existingValueType === 'array') {
                    var newValue = quickCloneArray(value);
                    output[key] = (options.arrayBehaviour === 'merge' ? output[key].concat(newValue) : newValue);
                }
                else {
                    output[key] = quickCloneArray(value);
                }
            }
            else {
                output[key] = value;
            }
        }
    }
    return output;
};
var objectAssignDeep = function (target) {
    var objects = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        objects[_i - 1] = arguments[_i];
    }
    return executeDeepMerge(target, objects);
};
export default objectAssignDeep;
export var noMutate = function () {
    var objects = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objects[_i] = arguments[_i];
    }
    return executeDeepMerge({}, objects);
};
export var withOptions = function (target, objects, options) {
    return executeDeepMerge(target, objects, options);
};
